import React from 'react';
import { FiAlertCircle, FiChevronUp, FiMinus, FiChevronDown } from 'react-icons/fi';
import { getTaskPriorityColor } from '../../api/tasks';

const TaskPriorityIndicator = ({ priority, showLabel = false, size = 'md' }) => {
  const priorityColor = getTaskPriorityColor(priority);

  const getPriorityLabel = (priority) => {
    const labels = {
      low: 'Low Priority',
      medium: 'Medium Priority',
      high: 'High Priority',
      urgent: 'Urgent'
    };
    return labels[priority] || priority;
  };

  const getPriorityIcon = (priority) => {
    const icons = {
      low: FiChevronDown,
      medium: FiMinus,
      high: FiChevronUp,
      urgent: FiAlertCircle
    };
    const Icon = icons[priority] || FiMinus;
    return Icon;
  };

  const Icon = getPriorityIcon(priority);

  const sizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5'
  };

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base'
  };

  if (showLabel) {
    return (
      <div className="flex items-center gap-2">
        <div
          className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full font-medium capitalize ${textSizeClasses[size]}`}
          style={{
            backgroundColor: priorityColor + '15',
            color: priorityColor
          }}
        >
          <Icon className={sizeClasses[size]} />
          {getPriorityLabel(priority)}
        </div>
      </div>
    );
  }

  return (
    <div
      className="inline-flex items-center justify-center rounded-full p-1"
      style={{
        backgroundColor: priorityColor + '20',
        color: priorityColor
      }}
      title={getPriorityLabel(priority)}
    >
      <Icon className={sizeClasses[size]} />
    </div>
  );
};

export default TaskPriorityIndicator;
